<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>远程预付费</el-breadcrumb-item>
      <el-breadcrumb-item>终端用户短信规则</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form  :inline="true">
      <el-form-item v-if="user.username == 'admin'" label="部门">
        <el-select v-model="depId"   placeholder="请选择"  size="small" @change="changeDept">
           <el-option
             v-for="item in deptData"
             :key="item.id"
             :label="item.departmentName"
             :value="item.id">
           </el-option>
         </el-select>
      </el-form-item>

    </el-form>
    <el-tabs type="border-card" @tab-click="tabChange">
      <el-tab-pane label="欠费提醒规则">
        <el-button @click="handelAddQf" style="margin-bottom: 10px;" type="primary" size="small">添加</el-button>

        <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
          style="width: 100%;" stripe :max-height="tableHeight"  :header-cell-style="this.$store.state.headerCss">
          <el-table-column align="center" type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column prop="template" label="模板">
          </el-table-column>
          <el-table-column prop="sign" label="签名">
          </el-table-column>
          <el-table-column prop="instant" label="发送时间">
          </el-table-column>
          <el-table-column prop="days" label="多少天发送一次">
          </el-table-column>
          <el-table-column prop="threshold" label="阈值">
          </el-table-column>
          <el-table-column label="是否是部门默认规则">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-if="scope.row.defaultFlag">是</el-tag>
              <el-tag size="small" type="info" v-if="!scope.row.defaultFlag">否</el-tag>
            </template>
          </el-table-column>


          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handeDetail(scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 2" @click="handelDateRuleWallet(scope.row)">绑定钱包</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 1" @click="handelDateRuleMeter(scope.row)">绑定计量点</el-button>
              <el-button type="danger" size="mini" @click="handelDeleQf(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="qfGet" @callFather="handelQfPage"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="余额提醒规则">
        <el-button @click="handelAddQf" style="margin-bottom: 10px;" type="primary" size="small">添加</el-button>
        <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
          style="width: 100%;" stripe :max-height="tableHeight"  :header-cell-style="this.$store.state.headerCss">
          <el-table-column align="center" type="index" width="60" label="序号">
          </el-table-column>
          <el-table-column prop="template" label="模板">
          </el-table-column>
          <el-table-column prop="sign" label="签名">
          </el-table-column>
          <el-table-column prop="instant" label="发送时间">
          </el-table-column>
          <el-table-column prop="days" label="多少天发送一次">
          </el-table-column>
          <el-table-column prop="threshold" label="阈值">
          </el-table-column>
          <el-table-column label="是否是部门默认规则">
            <template slot-scope="scope">
              <el-tag size="small" type="success" v-if="scope.row.defaultFlag">是</el-tag>
              <el-tag size="small" type="info" v-if="!scope.row.defaultFlag">否</el-tag>
            </template>
          </el-table-column>


          <el-table-column align="center" label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handeDetail(scope.row)">编辑</el-button>

              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 2" @click="handelDateRuleWallet(scope.row)">绑定钱包</el-button>
              <el-button type="warning" size="mini" v-if="depId != 0  && !scope.row.defaultFlag && deptType == 1" @click="handelDateRuleMeter(scope.row)">绑定计量点</el-button>
              <el-button type="danger" size="mini" @click="handelDeleQf(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="yeGet" @callFather="handelYePage"></Pagination>
      </el-tab-pane>

    </el-tabs>


    <el-dialog :title="qfTitle" :visible.sync="formVisible" width="60%" :close-on-click-modal="false">
    	<el-form  :model="qfFrom"  ref="editForm" :rules="rules">
        <el-row :gutter="12" >
          <el-col :span="4">
            <el-form-item  prop="templateId">
              <el-select size="small" placeholder="请选择模板" v-model="qfFrom.templateId" >
                <el-option
                  v-for="item in lsDeptData"
                  :key="item.id"
                  :label="item.templateName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="signId">
              <el-select size="small" placeholder="请选择签名" v-model="qfFrom.signId" >
                <el-option
                  v-for="item in signList"
                  :key="item.id"
                  :label="item.signName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="position: relative;">

            <el-form-item prop="threshold">
              <el-input size="small" placeholder="请输入阈值" v-model="qfFrom.threshold"></el-input>
            </el-form-item>
            <el-tooltip placement="top" effect="light">
              <div slot="content">
                <p>阈值格式：</p>
                <p>1:[0,20)</p>
                <p>2:'['左边中括号为开始的值, ‘)’右边小括号为结束的值 </p>
              </div>
              <i class="el-icon-warning iconPositon" ></i>
            </el-tooltip>
          </el-col>
          <el-col :span="4" >
            <el-form-item prop="days">
              <el-input size="small"  placeholder="多少天提醒一次" v-model="qfFrom.days" ></el-input>
            </el-form-item>
          </el-col>

         <el-col :span="4" >
            <el-form-item  prop="instant">
              <el-time-select
                size="small"
                :picker-options="{
                  start: '00:00',
                  step: '00:30',
                  end: '23:30'
                }"
                v-model="qfFrom.instant"
                placeholder="选择发送时间">
              </el-time-select>
            </el-form-item>
          </el-col>


        </el-row>

        <el-form-item label="是否默认"  v-if="depId != 0">
          <el-radio v-model="qfFrom.defaultFlag" :label="true">是</el-radio>
          <el-radio v-model="qfFrom.defaultFlag" :label="false">否</el-radio>
        </el-form-item>

    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="formVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="save">保存</el-button>
    	</div>
    </el-dialog>

    <el-dialog title="绑定钱包" :visible.sync="setFormVisible" width="45%"  :close-on-click-modal="false">
    	<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddWallet">添加</el-button>
    	<el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindWallet"  :disabled="!selectWallet.length" >删除</el-button>
    	<div style="line-height: 30px;">当前绑定的绑定钱包</div>
    	<el-table size="small" :data="walletList" height="500px" border v-loading="loadWallet"  @selection-change="getDeleWalletIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="钱包名称" prop="walletName"></el-table-column>
    	</el-table>
    	<div style="line-height: 40px;">共计:{{walletList.length}}</div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='setFormVisible = false'>关闭</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
    	</div>
    </el-dialog>


    <el-dialog title="选择钱包" :visible.sync="walletVisible" width="45%" :close-on-click-modal="false">
      <el-form  :inline="true">

        <el-form-item >
          <el-input style="width: 100%;" size="small" v-model="formInline.walletName" placeholder="请输入钱包名称"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="getAllWallets">搜索</el-button>
        </el-form-item>
      </el-form>
    	<el-table size="small" v-loading="walletLoad" :data="allWalletList" height="500px" border  @selection-change="getwalletIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="钱包名称" prop="walletName"></el-table-column>

    	</el-table>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='walletVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveBindWallet">保存</el-button>
    	</div>
    </el-dialog>



    <el-dialog title="绑定计量点" :visible.sync="bindFormVisible" width="45%"  :close-on-click-modal="false">
    	<el-button type="primary" size="small" style="margin-bottom: 10px;" @click="handelAddMeter">添加</el-button>
    	<el-button type="danger" size="small" style="margin-bottom: 10px;" @click="removeBindMeter"  :disabled="!selectMeter.length" >删除</el-button>
    	<div style="line-height: 30px;">当前绑定的计量点</div>
    	<el-table size="small" :data="meterList" height="500px" border v-loading="loadWallet"  @selection-change="getDeleMeterIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>
    	</el-table>
    	<div style="line-height: 40px;">共计:{{meterList.length}}</div>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='bindFormVisible = false'>关闭</el-button>
    		<!-- <el-button size="small" type="primary" :loading="setLoading" class="title" @click="subBindMeter('editForm')">保存</el-button> -->
    	</div>
    </el-dialog>


    <el-dialog title="选择计量点" :visible.sync="meterVisible" width="45%" :close-on-click-modal="false">
      <el-form  :inline="true">

        <el-form-item >
          <el-input style="width: 100%;" size="small"  v-model="getMeter.meterPointName" placeholder="请输入计量点名称"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="getAllMeterList">搜索</el-button>
        </el-form-item>
      </el-form>
    	<el-table size="small" v-loading="walletLoad" :data="allMeterList" height="500px" border  @selection-change="getMeterIds">
    		<el-table-column type="selection"></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterPointName"></el-table-column>

    	</el-table>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='meterVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveBindMeter">保存</el-button>
    	</div>
    </el-dialog>

  </div>
</template>

<script>
   import Pagination from '../../components/Pagination'
   import {
     list_prepaid_department,
     add_sms_arrear_notify_rule,
     list_sms_arrear_notify_rule,
     del_sms_arrear_notify_rule,
     del_sms_balance_notify_rule,
     update_sms_arrear_notify_rule,
     add_sms_balance_notify_rule,
     update_sms_balance_notify_rule,
     list_sms_balance_notify_rule,
     alist_wallet_by_rule,
     walletSelectByDptId2,
     sms_arrear_notify_rule_bind_wallet,
     sms_balance_notify_rule_bind_wallet,
     sms_arrear_notify_rule_unbind_wallet,
     sms_balance_notify_rule_unbind_wallet,
     sms_balance_notify_unbind_single_meter,
     mlist_wallet_by_rule,
     list_meter_info_by_rule,
     mlist_meter_info_by_rule,
     sms_arrear_notify_rule_bind_single_meter,
     sms_arrear_notify_rule_unbind_single_meter,
     sms_balance_notify_bind_single_meter

   } from '../../api/payMG'
   import {
     getAllMsgSign,
     getAllMsgTemplate
   } from '../../api/userMG.js'
   import {
     getDepartmentIdByMeterInfos
   } from '../../api/energyMG'

   export default{
     data(){
       return{
         getMeter:{
           meterPointName:"",
           depId:"",
         },
         walletLoad:false,
         meterVisible:false,
         tableHeight:0,
         depId:0,
         deptType:-1,
         walletVisible:false,
         walletList:[],
         meterList:[],
         allMeterList:[],
         user:{},
         qfFrom:{
            days: 0,
           	defaultFlag: false,
           	departmentId: '',
           	instant: "",
           	signId: '',
           	templateId: '',
           	threshold: ""
         },
         meterIds:[],
         bindFormVisible:false,
         allWalletList:[],
         formInline: {
           depId: '',
           currentPage: 1,
           pageSize: 99999,
           total:0,
           walletName: "",
         },
         selectWallet:[],
         selectMeter:[],
         dataType:0,
         qfTitle:"",
         qfGet:{
           departmentId:"",
           currentPage:1,
           pageSize:10,
           total:0
         },
         yeGet:{
           departmentId:"",
           currentPage:1,
           pageSize:10,
           total:0
         },

         walletIds:[],
         deptData:[],

          loadWallet:false,
         formVisible:false,
         DateTitle:"",
         yuZhiList:[],
         dataList:[],
         loading:false,
         yuZhiGet:{},
         setLoading:false,
         templateList:[],
         lsDeptData:[],
         signList:[],
         curId:"",
         setFormVisible:false,
         rules: {

           days:[{ required: true, message: '请输入多少天提醒一次',trigger: 'blur' }],
           instant :[{ required: true, message: '请选择发送时间',trigger: 'chagne' }],
           signId :[{ required: true, message: '请选择签名',trigger: 'chagne' }],
           templateId :[{ required: true, message: '请选择模板',trigger: 'chagne' }],
           threshold :[{ required: true, message: '请输入阈值',trigger: 'blur' }],
         },

       }
     },
     mounted() {
       this.$nextTick(() => {
         this.tableHeight = window.innerHeight - 360
       })
     },
     created() {
        this.user = JSON.parse(sessionStorage.getItem('userdata'))
        this.getDeptData()
        this.getSign()
        this.getTemplate()

     },
     components: {
       Pagination
     },
     methods:{
       getDeptData(){
         list_prepaid_department().then(res => {
            if(res.status == 1){
              this.deptData = res.data
              this.depId = res.data[0].id
              this.qfFrom.departmentId = this.depId
               this.deptType = res.data[0].payType
              this.getQfData()
            }
         })
       },

       handelDateRuleMeter(row){
         this.bindFormVisible = true
         this.curId = row.id
         this.getMeterListByRuleId()
       },


       getMeterListByRuleId(){
         let param = {
           ruleType:this.dataType == 0 ? 'ARREAR_NOTIFY' : 'BALANCE_NOTIFY',
           ruleId:this.curId
         }
         mlist_meter_info_by_rule(param).then(res => {

           if(res.status == 1){
             this.meterList = res.data
           }else{
             this.$message.error(res.msg)
           }
         })
       },

       handelAddMeter(){
         this.meterVisible = true
         this.getAllMeterList()

       },

       getAllMeterList(){
         this.walletLoad = true
          this.getMeter.depId = this.depId
         getDepartmentIdByMeterInfos(this.getMeter).then(res => {
           this.walletLoad = false
           if(res.status == 1){
             this.allMeterList = res.data
           }
         })
       },

       handelAddWallet(){
        this.walletLoad = true
        this.walletVisible = true
        this.formInline.walletName = ''
        this.getAllWallets()
       },


       getAllWallets(){
         walletSelectByDptId2(this.formInline).then(res => {
           this.walletLoad = false
           if(res.status == 1){
             this.allWalletList = res.data.data
           }

         })
       },


       getDeleWalletIds(e){
         this.selectWallet = e
       },
       getDeleMeterIds(e){
         this.selectMeter = e
       },

       handelQfPage(parm){
         this.qfGet.currentPage = parm.currentPage
         this.qfGet.pageSize = parm.pageSize
         this.getQfData()

       },
       handelYePage(parm){
         this.yeGet.currentPage = parm.currentPage
         this.yeGet.pageSize = parm.pageSize
         this.getYeData()

       },

       removeBindWallet(){
        this.setLoading = true
        let param = {
          ruleId:this.curId,
          walletIds:this.selectWallet.map(item => item.id)
        }


        if(this.dataType == 0){

          sms_arrear_notify_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getWalletList()


            }else{
              this.$message.error(res.msg)
            }
          })
        }else{
          sms_balance_notify_rule_unbind_wallet(param).then(res => {
            this.setLoading = false
            if(res.status == 1){
              this.$message.success('操作成功！')
               this.getWalletList()

            }else{
              this.$message.error(res.msg)
            }
          })
        }
       },


       removeBindMeter(){
         this.setLoading = true
         let param = {
           ruleId:this.curId,
           meterInfoIds:this.selectMeter.map(item => item.id)
         }
         if(this.dataType == 0){
           sms_arrear_notify_rule_unbind_single_meter(param).then(res => {
             this.setLoading = false
             if(res.status == 1){
               this.$message.success('操作成功！')
                this.getMeterListByRuleId()

             }else{
              this.$message.error(res.msg)
            }
           })
         }else{
           sms_balance_notify_unbind_single_meter(param).then(res => {
             this.setLoading = false
             if(res.status == 1){
               this.$message.success('操作成功！')
               this.getMeterListByRuleId()

             }else{
              this.$message.error(res.msg)
            }
           })
         }
       },

       saveBindWallet(){
          this.setLoading = true
          let param = {
            ruleId:this.curId,
            walletIds:this.walletIds.map(item => item.id)
          }


          if(this.dataType == 0){

            sms_arrear_notify_rule_bind_wallet(param).then(res => {
              this.setLoading = false
              if(res.status == 1){
                this.$message.success('操作成功！')
                this.walletVisible = false
                this.getWalletList()

              }else{
                this.$message.error(res.msg)
              }
            })
          }else if( this.dataType == 1 ){

            sms_balance_notify_rule_bind_wallet(param).then(res => {
              this.setLoading = false
              if(res.status == 1){
                this.$message.success('操作成功！')
                this.walletVisible = false
                this.getWalletList()

              }else{
                this.$message.error(res.msg)
              }
            })
          }
       },

       saveBindMeter(){
         this.setLoading = true
         let param = {
           ruleId:this.curId,
           meterInfoIds:this.meterIds.map(item => item.id)
         }


         if(this.dataType == 0){

           sms_arrear_notify_rule_bind_single_meter(param).then(res => {
             this.setLoading = false
             if(res.status == 1){
               this.$message.success('操作成功！')
               this.meterVisible = false
               this.getMeterListByRuleId()

             }else{
                this.$message.error(res.msg)
              }
           })
         }else if( this.dataType == 1 ){

           sms_balance_notify_bind_single_meter(param).then(res => {
             this.setLoading = false
             if(res.status == 1){
               this.$message.success('操作成功！')
               this.meterVisible = false
               this.getMeterListByRuleId()

             }else{
                this.$message.error(res.msg)
              }
           })
         }
       },
       getQfData(){
         this.loading = true
         this.qfGet.departmentId = this.depId
         list_sms_arrear_notify_rule(this.qfGet).then(res => {
            this.loading = false
            if(res.status == 1){
              this.dataList = res.data.content
              this.qfGet.total =res.data.totalElements
            }else{
              this.$message.error(res.msg)
            }
         })
       },

       getYeData(){
         this.loading = true
         this.yeGet.departmentId = this.depId
         list_sms_balance_notify_rule(this.yeGet).then(res => {
            this.loading = false
            if(res.status == 1){
              this.dataList = res.data.content
              this.yeGet.total =res.data.totalElements
            }
         })
       },

       //获取所有的签名
       getSign(){
         getAllMsgSign().then(res =>{
           if(res.status == 1){
             this.signList = res.data
           }
         })
       },
       // 获取所有的模板
       getTemplate(){
         getAllMsgTemplate().then(res => {
           if(res.status == 1){
             this.templateList = res.data
             this.lsDeptData =  this.templateList.filter( item => {
                if(item.templateName.indexOf('欠费') != -1){
                  return item
                }
              })
           }
         })
       },

       handelDateRuleWallet(row){

         this.setFormVisible = true
         this.curId = row.id
         this.formInline.depId = this.depId
         this.getWalletList()
       },

       getWalletList(){
         let pram = {
           ruleType:this.dataType == 0 ? 'ARREAR_NOTIFY':'BALANCE_NOTIFY',
           ruleId:this.curId
         }

         this.loadWallet = true
         alist_wallet_by_rule(pram).then(res => {
           this.loadWallet = false
           if(res.status == 1){
              this.walletList = res.data
           }
         })
       },

       getwalletIds(e){
         this.walletIds = e
       },

       getMeterIds(e){
         this.meterIds = e
       },

       callFather(){

       },
       handelAddQf(){
         this.qfFrom.departmentId = this.depId
         this.qfFrom.days = ""
         this.qfFrom.defaultFlag = this.depId == 0 ? true:false
         this.qfFrom.instant = ""
         this.qfFrom.signId =  ""
         this.qfFrom.templateId = ""
         this.qfFrom.threshold = ""
         this.formVisible = true
         this.qfTitle = '添加'
         this.qfFrom.id = ''
       },
       handeDetail(row){

          this.qfFrom.id = row.id
          this.qfFrom.days = row.days
          this.qfFrom.defaultFlag = row.defaultFlag
          this.qfFrom.departmentId = row.departmentId
          this.qfFrom.instant = row.instant
          this.qfFrom.signId =  row.signId
          this.qfFrom.templateId = row.templateId
          this.qfFrom.threshold = row.threshold
          this.qfTitle = '修改'
          this.formVisible = true


       },
       save(){
          this.$refs['editForm'].validate( valid => {
            if(valid){
              if(this.qfTitle == '添加'){
                if(this.dataType == 0){
                  this.addQf()
                }else{
                  this.addYe()
                }
              }else{
                if(this.dataType == 0){
                  this.updateQf()
                }else{
                  this.updateYe()
                }

              }
            }
          })



       },
       addQf(){

         add_sms_arrear_notify_rule(this.qfFrom).then(res => {
           if(res.status == 1){
             this.$message.success('操作成功')
             this.getQfData()
             this.formVisible = false
           }else{
             this.$message.error(res.msg)
           }
         })
       },
       updateQf(){
         update_sms_arrear_notify_rule(this.qfFrom).then(res => {
           if(res.status == 1){
             this.$message.success('操作成功')
             this.getQfData()
             this.formVisible = false
           }else{
             this.$message.error(res.msg)
           }
         })
       },

       addYe(){
         add_sms_balance_notify_rule(this.qfFrom).then(res => {
           if(res.status == 1){
             this.$message.success('操作成功')
             this.getYeData()
             this.formVisible = false
           }else{
             this.$message.error(res.msg)
           }
         })
       },

       updateYe(){
         update_sms_balance_notify_rule(this.qfFrom).then(res => {
           if(res.status == 1){
             this.$message.success('操作成功')
             this.getYeData()
             this.formVisible = false
           }else{
             this.$message.error(res.msg)
           }
         })
       },

       handelDeleQf(row){
         this.$confirm('确定要删除吗?', '信息', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
           this.curId = row.id
           if(this.dataType == 0){
             del_sms_arrear_notify_rule({ id:row.id }).then(res => {
                if(res.status == 1){
                  this.$message.success("操作成功!")
                  this.getQfData()
                }else{
                  this.$message.error(res.msg)
                }
             })
           }else{
             del_sms_balance_notify_rule({ id:row.id }).then(res => {
                if(res.status == 1){
                  this.$message.success("操作成功!")
                  this.getYeData()
                }else{
                  this.$message.error(res.msg)
                }
             })
           }

         })
       },



       handelPage(){

       },
       changeDept(e){

        this.deptType = this.deptData.filter(item => item.id == e)[0].payType
        if(this.dataType == 0){
          this.getQfData()
        }else{
          this.getYeData()
        }
       },
       handelAddYe(){
        this.formVisible = true

       },


       tabChange(e){
        this.dataType = e.index
        if(this.dataType == 0){
          this.getQfData()
          this.lsDeptData =  this.templateList.filter( item => {
             if(item.templateName.indexOf('欠费') != -1){
               return item
             }
           })

        }else{
          this.getYeData()
          this.lsDeptData =  this.templateList.filter( item => {
             if(item.templateName.indexOf('余额') != -1){
               return item
             }
           })
        }

       },
       addForm(){

       }
     }
   }
</script>

<style scoped>
.iconPositon{
    position: absolute;
    right: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/prepayment/messageSet.vue